var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconmaterialPlayCircleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-play-circle-outline",
    "data-name": "Icon material-play-circle-outline",
    d: "M8.2,12.425,12.1,9.5,8.2,6.575ZM9.5,3A6.5,6.5,0,1,0,16,9.5,6.5,6.5,0,0,0,9.5,3Zm0,11.7a5.2,5.2,0,1,1,5.2-5.2A5.207,5.207,0,0,1,9.5,14.7Z",
    transform: "translate(-3 -3)",
    fill: "#7a7a7a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconmaterialPlayCircleOutline);
export default __webpack_public_path__ + "static/media/Icon material-play-circle-outline.d87cd418.svg";
export { ForwardRef as ReactComponent };